import axios from "axios";

export const fetchDeleteTaskSubmission = async (id: string) => {
  const baseTaskUrl = process.env.REACT_APP_TASK_API_URL;
  return await axios.delete(`${baseTaskUrl}/TaskSubmission/${id}`);
};
